export default async function UpdateUserCycleLockApi(userId, lockedCycleId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "*/*",
        Authorization: token,
      },
      body: JSON.stringify({ lockedCycleId: lockedCycleId ?? null }),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/users/${userId}/lock-cycle`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error updating cycle lock: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }
  return res;
}
